import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.CilindroTipo &&
    params.CilindroTipo.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCilindroTipo=${params.CilindroTipo.Codigo}`);
  params.CantidadCilindros &&
    (path = `${path !== '' ? `${path}&` : ''}CantidadCilindros=${params.CantidadCilindros}`);
  params.CantidadMagneticos &&
    (path = `${path !== '' ? `${path}&` : ''}CantidadMagneticos=${params.CantidadMagneticos}`);
  ['CantidadAlmasStamping', 'CantidadCilindrosRelieveEnLinea'].forEach((key) => {
    if (params[key] !== null && params[key] !== undefined) {
      path = `${path !== '' ? `${path}&` : ''}${key}=${params[key]}`;
    }
  });
  if (params.Activo !== null) {
    path = `${path ? `${path}&` : ''}Activo=${params.Activo}`;
  }

  return path;
};
